import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";

/**
 * Admin emails per organization, keyed by organization id. Fetches only when
 * `enabled` (i.e. the current user is a super admin); the RPC itself also
 * returns zero rows for non-super-admins.
 */
export function useWorkspaceAdminEmails(enabled: boolean) {
  const [emailsByOrg, setEmailsByOrg] = useState<Record<string, string[]>>({});

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    supabase.rpc("get_workspace_admin_emails").then(({ data, error }) => {
      if (cancelled || error || !data) return;
      setEmailsByOrg(
        Object.fromEntries(data.map((row) => [row.organization_id, row.admin_emails])),
      );
    });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return emailsByOrg;
}
